import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { MaintenanceWindowPatchManagementVendorProductSelectorDataProviderFactory } from '../factory/MaintenanceWindowPatchManagementVendorProductSelectorDataProviderFactory';
import { MaintenanceWindowPatchManagementVendorProductSelectorBaseDataProvider } from '../dataProvider/MaintenanceWindowPatchManagementVendorProductSelectorBaseDataProvider';
import { ProductRecord, VendorRecord } from '../types';

export class MaintenanceWindowPatchManagementVendorProductSelectorRepository extends BaseWebComponentRepository {
  public dataProviderFactory: MaintenanceWindowPatchManagementVendorProductSelectorDataProviderFactory;
  public dataProvider: MaintenanceWindowPatchManagementVendorProductSelectorBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new MaintenanceWindowPatchManagementVendorProductSelectorDataProviderFactory(),
    });
  }

  async getAllVendors(): Promise<VendorRecord[]> {
    return this.dataProvider.getAllVendors();
  }

  async getProductsForVendor(params: { vendorId: string }): Promise<ProductRecord[]> {
    return this.dataProvider.getProductsForVendor(params);
  }
}
